import { Box, Typography } from '@mui/material';
import { isModalComplete } from 'src/components/ModalDialog';
import DataTable, {
  DataTableWrapper,
  DataTableWrapperActionButton,
} from 'src/components/DataTable';
import { useModal } from 'src/hooks';
import { useUserRoles } from 'src/auth';
import DateFormattedValue from 'src/components/DateFormattedValue';
import SolutionSourcePullImageConfig from './SolutionSourcePullImageModal';
import {
  SolutionSourcePullDockerImageItemField,
  SourceImageRepoData,
} from '../../types';
import SolutionDockerImagesStatus from './SolutionDockerImagesStatus';
import SolutionWorkloadMessage from '../../SolutionEdgeWorkload/components/SolutionWorkloadMessage';

type Props = {
  item?: SourceImageRepoData;
  loading?: boolean;
};

const columns = [
  {
    id: SolutionSourcePullDockerImageItemField.SourceImageRepoName,
    title: 'Repository Name',
  },
  {
    id: SolutionSourcePullDockerImageItemField.ImageName,
    title: 'Image name',
  },
  {
    id: SolutionSourcePullDockerImageItemField.Tag,
    title: 'Tag',
  },
  {
    id: SolutionSourcePullDockerImageItemField.Status,
    title: 'Status',
    Component: SolutionDockerImagesStatus,
  },
  {
    id: SolutionSourcePullDockerImageItemField.RequestedDate,
    title: 'Created',
    Component: DateFormattedValue,
  },
  {
    id: SolutionSourcePullDockerImageItemField.FailedReason,
    title: 'Message',
    Component: SolutionWorkloadMessage,
  },
];

function SolutionDockerImages({ item, loading }: Props) {
  const { isPlatformEngineer, isPlatformReader } = useUserRoles();
  const [CreatePullDockerImagesDialog, showPullDockerImagesDialog] = useModal(
    SolutionSourcePullImageConfig,
    {
      item,
      onClose: (reason) => isModalComplete(reason),
    }
  );

  return (
    <DataTableWrapper
      searchBar={false}
      actionsPanel={
        <DataTableWrapperActionButton
          disabled={isPlatformReader || isPlatformEngineer}
          onClick={showPullDockerImagesDialog}
          sx={{ padding: '7px 43px', marginTop: '20px' }}
          className="pulldockerimage"
        >
          Pull docker Images
        </DataTableWrapperActionButton>
      }
    >
      <Typography
        style={{
          fontWeight: 'bold',
          fontSize: '17px',
          paddingRight: '12px',
        }}
      >
        Docker Images
      </Typography>
      {item?.sourceDockerImages ? (
        <DataTableWrapper searchBar={true}>
          <DataTable
            columns={columns}
            data={item?.sourceDockerImages}
            loading={loading}
          />
        </DataTableWrapper>
      ) : (
        <Box>
          <Typography variant="body2" color="#A5A5A5" align="center">
            No data to display
          </Typography>
        </Box>
      )}
      {CreatePullDockerImagesDialog}
    </DataTableWrapper>
  );
}

export default SolutionDockerImages;
